import React from 'react';

function AttendanceHeader() {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold text-gray-900">Attendance Management</h1>
      </div>
    </header>
  );
}

export default AttendanceHeader;